const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];

// Meta's ad review opens every new ad from its own data centres minutes after
// the ad is published, with a normal browser user agent. It encodes the URL
// tags twice, so a value still holds a percent escape after one decode
// ("Kampagne %7C Test"); a real click never does. The visit starts the wizard
// and goes no further, so it reads as a paid visitor who dropped off.
export function isAdReviewVisit(search: string): boolean {
  const params = new URLSearchParams(search);
  return UTM_KEYS.some((key) => /%[0-9a-f]{2}/i.test(params.get(key) ?? ""));
}
